module.exports = __webpack_public_path__ + "static/media/video4.9aefb7a7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/app/how-can-be-used/assets/video4.mp4
// module id = 102
// module chunks = 0